export default function(instance) {
  return {
    getNotifications(data) {
      return instance.get("/api/notifications/admin/", { params: data });
    },
    syncNotification(idNotification) {
      return instance.get(`/api/notifications/sync/${idNotification}/`);
    },
    getCountNotifications() {
      return instance.get("/api/notifications/number/admin/");
    }
  };
}
